import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import {
  Target,
  ShieldCheck,
  Brain,
  Zap,
  Waves,
  Network,
  RefreshCw,
  Heart,
} from "lucide-react";
import CosmicBackground from "./CosmicBackground";

const ICONS = [Target, ShieldCheck, Brain, Zap, Waves, Network, RefreshCw, Heart];
const COLOR_CYCLE = ["#FF2D5C", "#FF3DCB", "#9B4DFF", "#3DBFFF"];

const Banen = () => {
  const { t } = useTranslation();
  const cards = t("banen.cards", { returnObjects: true });

  return (
    <section
      id="banen"
      data-testid="banen-section"
      className="relative section-pad overflow-hidden bg-[#05020E]"
    >
      <CosmicBackground variant="football" />

      <div className="relative mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="flex flex-col items-start gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="eyebrow">{t("banen.eyebrow")}</span>
            <h2 className="font-display mt-5 text-xl sm:text-[1.5rem] lg:text-[1.75rem] font-semibold leading-[1.18] text-white glow-text-white uppercase tracking-[-0.005em]">
              {t("banen.title")}
            </h2>
          </div>
          <p className="max-w-sm text-base md:text-lg text-white/70 leading-relaxed">
            {t("banen.lead")}
          </p>
        </div>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {Array.isArray(cards) &&
            cards.map((label, i) => {
              const Icon = ICONS[i % ICONS.length];
              const color = COLOR_CYCLE[i % COLOR_CYCLE.length];
              return (
                <motion.div
                  key={i}
                  data-testid={`banen-card-${i}`}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.55, delay: (i % 4) * 0.07 }}
                  className="group relative flex flex-col gap-4 overflow-hidden rounded-xl glass p-6 electric-border"
                >
                  <div
                    className="flex h-10 w-10 items-center justify-center rounded-lg"
                    style={{
                      background: `linear-gradient(135deg, ${color}30, transparent)`,
                      boxShadow: `0 0 24px -8px ${color}90`,
                    }}
                  >
                    <Icon className="h-5 w-5" style={{ color }} />
                  </div>
                  <p className="font-display text-base font-medium leading-snug text-white">
                    {label}
                  </p>
                  <span
                    className="absolute right-4 top-4 font-mono text-[10px] uppercase tracking-widest opacity-50"
                    style={{ color }}
                  >
                    0{i + 1}
                  </span>
                  {/* Decorative bar that fills on hover */}
                  <div className="absolute bottom-0 left-0 h-[2px] w-0 group-hover:w-full transition-all duration-700"
                    style={{ background: `linear-gradient(90deg, ${color}, transparent)` }}
                  />
                </motion.div>
              );
            })}
        </div>
      </div>
    </section>
  );
};

export default Banen;
